import React from "react";
import FaceIcon from "@mui/icons-material/Face";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { Box, Button, Stack, Typography } from "@mui/material";
import { kFormatter } from "../../constants/function";
import { HistoryBefore, TipsAndUpdatesSharp } from "@mui/icons-material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import PlaylistPlayRoundedIcon from "@mui/icons-material/PlaylistPlayRounded";
import ShortcutOutlinedIcon from "@mui/icons-material/ShortcutOutlined";
import { Images } from "../../assets/common";
// import PanToolAltOutlinedIcon from "@mui/icons-material/PanToolAltOutlined";
export default function AnalyticsBtn({
  view,
  tip,
  play,
  share,
  follow,
  history,
  activeIndex,
  index,
  onClick,
  image,
  name,
}) {
  return (
    <Button
      onClick={() => {
        history(
          view != undefined
            ? "Views"
            : tip != undefined
            ? "Tips"
            : play != undefined
            ? "Streams"
            : follow != undefined
            ? "Follow"
            : share != undefined
            ? "Share"
            : "Views"
        );
        onClick(index);
      }}
      className={
        "__play_all" +
        "_cp" +
        (activeIndex === index ? " __color_btn" : " __normal_btn") +
        " fs-14 "
      }
      sx={{
        // width: "68px",
        minWidth: "78px",
        height: "30px !important",
        // margin: "0px !important",
        fontSize: "12px !important",
        fontWeight: "400 !important",
        color: "#A5A5A5",
      }}
      variant="outlined"
      color="default"
      startIcon={
        <img
          style={{ width: "24px", marginRight: "0px !important" }}
          src={image}
          alt={name}
        />
      }
      title={
        view != undefined
          ? view
          : tip != undefined
          ? tip
          : play != undefined
          ? play
          : share != undefined
          ? share
          : follow != undefined
          ? follow
          : null
      }
    >
      {view
        ? kFormatter(view.toFixed(1))
        : tip
        ? "$" + kFormatter(tip.toFixed(1))
        : play
        ? kFormatter(play)
        : share
        ? kFormatter(share)
        : follow
        ? kFormatter(follow)
        : 0}
    </Button>
  );
}
